import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { ReactComponent as Caret } from '../../../images/icons/caret-down.svg';
import { colors } from '../../../theme/colors';
import { headers } from '../../../styles/type';
import { fontWeights } from '../../../theme/type';
import { rem } from '../../../utilities/style';
import TextRenderer from '../../TextRenderer';

const Wrapper = styled.div`

`;

const Content = styled.div`
 ${({ expanded }) => expanded && `
    display: none;
  `}
`;

const Expandable = styled.div`
  display: none;

  ${({ expanded }) => expanded && `
    display: block;
  `}
`;

const ToggleButton = styled.button`
  ${headers.h7}
  font-weight: ${fontWeights.bold};
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  border: none;
  background-color: transparent;
  color: ${colors.blue['500']};
  margin-top: ${rem(8)};
  cursor: pointer;
`;

const StyledCaret = styled(Caret, {
  shouldForwardProp: (prop) => !['expanded'].includes(prop)
})`
  transition: transform 200ms ease;

 ${({ expanded }) => expanded && `
    transform: rotate(-180deg);
  `}
`;

const ExpandableContent = ({
  content,
  expandedContent,
  expandedButtonText,
  collapseButtonText
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Wrapper>
      <Content expanded={isExpanded}>{content}</Content>
      <Expandable expanded={isExpanded}>
        {expandedContent}
      </Expandable>
      {expandedButtonText && collapseButtonText && (
        <ToggleButton onClick={() => setIsExpanded(!isExpanded)}>
          <TextRenderer text={isExpanded ? collapseButtonText : expandedButtonText} />
          <StyledCaret expanded={isExpanded} />
        </ToggleButton>
      )}
    </Wrapper>
  );
};

ExpandableContent.propTypes = {
  content: PropTypes.node.isRequired,
  expandedContent: PropTypes.node.isRequired,
  expandedButtonText: PropTypes.string,
  collapseButtonText: PropTypes.string
};

export default ExpandableContent;
